<template>
  <div class="editor-container" id="illustration">
    <div class="fixed">
      <EditorMenu />
      <GlassPreview />
    </div>
    <div class="product-fields">
      <!-- Sold -->
      <SoldCapacity v-if="soldCapacity"/>
      <!-- Editor -->
      <div class="form-fields">
        <ImageHandler />
        <HowWork/>
        <PhotoStyle />
        <GlobalAttributes type="illustration" />
        <AddToCart />
      </div>
      <Loader />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import AddToCart from "./AddToCart.vue";
import useProduct from "../useProduct";
import PhotoStyle from "./illustration/PhotoStyle.vue";
import HowWork from "./illustration/HowWork.vue";
import ImageHandler from "./ImageHandler.vue";
import Loader from "../../../packages/views/loader/Loader.vue";
import GlobalAttributes from "./attributes/GlobalAttributes.vue";
import useLover from "../useLover";
import GlassPreview from "./glass-preview/Base";
import EditorMenu from "./EditorMenu.vue";
import SoldCapacity from "./SoldCapacity.vue";

export default {
  components: {
    Loader,
    ImageHandler,
    PhotoStyle,
    AddToCart,
    GlobalAttributes,
    GlassPreview,
    EditorMenu,
    HowWork,
    SoldCapacity
},
  computed: {
    ...mapGetters({
      product: "product/getProduct",
      attributes: "product/getAttributes",
      soldCapacity: 'product/getSoldCapacity',
    }),
  },
  setup() {
    const { names, date, place, hasElement } = useLover();
    const { imageUrl } = useProduct();

    return {
      hasElement,
      names,
      date,
      place,
      imageUrl,
    };
  },
};
</script>
